import { palettes } from '@rei/landing-palettes';

export default {
  data() {
    return {
      paletteVars: palettes(this.palette || {
        content: 'primary',
        surface: 'primary',
      }),
    };
  },
  props: {
    palette: {
      type: Object,
      required: false,
      default: () => ({
        content: 'primary',
        surface: 'primary',
      }),
    },
  },
  computed: {
    cssSurfacePaletteVars() {
      return this.paletteVars?.cssSurfacePaletteVars();
    },
    cssContentPaletteVars() {
      return this.paletteVars?.cssContentPaletteVars();
    },
  },
};
